import { NgModule } from '@angular/core';
import { MainLayoutComponent } from './main-layout.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidenavLinkComponent } from './components/sidenav-link/sidenav-link.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { MatRippleModule } from '@angular/material/core';
import { InactivityListenerModule } from '../inactivity-listener/inactivity-listener.module';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { IconsComponent, InputComponent } from '@migo-apps/migo-uikit-v4';
import { SearchClientDialogComponent } from './components/search-client-dialog/search-client-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { AutoScrollTickerDirective } from './directives/auto-scroll-ticker.directive';

@NgModule({
  declarations: [
    MainLayoutComponent,
    SidenavLinkComponent,
    UserInfoComponent,
    BreadcrumbComponent,
    SearchClientDialogComponent,
    ContextMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatRippleModule,
    InactivityListenerModule,
    TranslateModule,
    IconsComponent,
    MatDialogModule,
    InputComponent,
    AutoScrollTickerDirective,
  ],
  exports: [MainLayoutComponent],
})
export class MainLayoutComponentModule {}
